import * as GQL from '~/graphql/generated/client';

const WORKFLOW_STATUS_LABELS: Record<GQL.AssessmentStatusType, string> = {
  [GQL.AssessmentStatusType.NotStarted]: 'Not Started',
  [GQL.AssessmentStatusType.InProgress]: 'In Progress',
  [GQL.AssessmentStatusType.InValidation]: 'In Validation',
  [GQL.AssessmentStatusType.WaitingForApproval]: 'Waiting for Approval',
  [GQL.AssessmentStatusType.InReview]: 'In Review',
  [GQL.AssessmentStatusType.Approved]: 'Approved',
  [GQL.AssessmentStatusType.Rejected]: 'Rejected',
  [GQL.AssessmentStatusType.Archived]: 'Archived',
  [GQL.AssessmentStatusType.Cancelled]: 'Cancelled',
  [GQL.AssessmentStatusType.Published]: 'Published',
  [GQL.AssessmentStatusType.Reviewed]: 'Reviewed',
};

export function formatWorkflowStatus(
  status: GQL.AssessmentStatusType | null | undefined
): string {
  if (!status) {
    return 'N/A';
  }
  return WORKFLOW_STATUS_LABELS[status] ?? status;
}

export const ASSESSMENT_STATUS_COLUMNS = [
  { label: 'Pre-Screening', index: 0 },
  { label: 'Privacy', index: 1 },
  { label: 'Safeguard', index: 2 },
] as const;
